import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const userMenus = (): CloudPremisePluginMenu[] => {
    return [];
};

export default userMenus;